/* ==========================================================================
   KWF — CRO wireframe behaviours (Home, Collection, Product, Cart drawer)
   Vanilla JS, no dependencies. Works with the theme's existing cart drawer
   (<cart-notification>), quick view (<select-option>) and wishlist (<button-wishlist>).
   ========================================================================== */
(function () {
  'use strict';

  var KWF = (window.KWF = window.KWF || {});
  var doc = document;
  var $ = function (s, r) {
    return (r || doc).querySelector(s);
  };
  var $$ = function (s, r) {
    return Array.prototype.slice.call((r || doc).querySelectorAll(s));
  };
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';


  doc.addEventListener('change', function (event) {
    var select = event.target.closest('[data-kwf-upsell-variant]');
    if (!select) return;
    var card = select.closest('[data-kwf-upsell-card]');
    var option = select.options[select.selectedIndex];
    var price = Number(option.getAttribute('data-price'));
    var compare = Number(option.getAttribute('data-compare'));
    var add = card.querySelector('[data-kwf-add]');
    add.setAttribute('data-kwf-add', select.value);
    add.disabled = option.disabled;
    card.querySelector('[data-kwf-upsell-price]').textContent = KWF.money(price);
    var oldPrice = card.querySelector('[data-kwf-upsell-compare]');
    oldPrice.textContent = KWF.money(compare);
    oldPrice.hidden = !(compare > price);
    var badge = card.querySelector('[data-kwf-upsell-discount]');
    badge.hidden = !(compare > price);
    if (compare > price) badge.textContent = Math.floor((compare - price) * 100 / compare) + '% off';
  });

  KWF.money = function (cents) {
    var n = Math.round(Number(cents) || 0);
    return (
      '₹' +
      (n / 100).toLocaleString('en-IN', {
        minimumFractionDigits: n % 100 ? 2 : 0,
        maximumFractionDigits: 2,
      })
    );
  };

  KWF.store = {
    get: function (key, fallback) {
      try {
        var v = localStorage.getItem(key);
        return v == null ? fallback : JSON.parse(v);
      } catch (e) {
        return fallback;
      }
    },
    set: function (key, value) {
      try {
        localStorage.setItem(key, JSON.stringify(value));
      } catch (e) {}
    },
    remove: function (key) {
      try {
        localStorage.removeItem(key);
      } catch (e) {}
    },
  };

  KWF.escape = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };

  KWF.toast = function (message, isError) {
    if (typeof window.showToast === 'function') {
      try {
        window.showToast(
          '<div class="form__message ' + (isError ? 'error' : 'success') + ' inline-flex align-center">' + KWF.escape(message) + '</div>',
          4000,
          isError ? 'modal-error' : 'modal-success'
        );
        return;
      } catch (e) {}
    }
    var el = doc.createElement('div');
    el.className = 'kwf-toast' + (isError ? ' kwf-toast--error' : '');
    el.setAttribute('role', 'status');
    el.textContent = message;
    doc.body.appendChild(el);
    setTimeout(function () {
      el.remove();
    }, 4000);
  };

  /* ------------------------------------------------------------------ cart */
  KWF.cartEl = function () {
    return $('cart-notification');
  };

  KWF.hasDrawer = function () {
    var cart = KWF.cartEl();
    return !!(cart && $('.minicart__wrapper', cart) && doc.getElementById('minicart-form'));
  };

  KWF.setCount = function (count) {
    $$('.cart-count').forEach(function (el) {
      if (el.classList.contains('cart-count-drawer')) el.innerHTML = '(' + count + ')';
      else el.textContent = count > 100 ? '~' : count;
    });
  };

  KWF.getCart = function () {
    return fetch(root + 'cart.js', { cache: 'no-store', credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  };

  KWF.refreshDrawer = function (sections) {
    var apply = function (html) {
      if (!html) throw new Error('Cart content could not be refreshed. Please try again.');
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var src = parsed.querySelector('#minicart-form');
      var dst = doc.getElementById('minicart-form');
      if (!src || !dst) throw new Error('Cart content could not be refreshed. Please try again.');
      var scroll = dst.querySelector('.kwf-cart__scroll');
      var scrollTop = scroll ? scroll.scrollTop : 0;
      var rail = dst.querySelector('.kwf-upsell__list');
      var scrollLeft = rail ? rail.scrollLeft : 0;
      var activeId = dst.contains(doc.activeElement) ? doc.activeElement.id : '';
      dst.innerHTML = src.innerHTML;
      var nextScroll = dst.querySelector('.kwf-cart__scroll');
      if (nextScroll) nextScroll.scrollTop = scrollTop;
      var nextRail = dst.querySelector('.kwf-upsell__list');
      if (nextRail) nextRail.scrollLeft = scrollLeft;
      var nextFocus = activeId && doc.getElementById(activeId);
      if (nextFocus) nextFocus.focus({ preventScroll: true });
      var cart = KWF.cartEl();
      if (cart && typeof cart.cartAction === 'function') cart.cartAction();
    };
    var p;
    if (sections && sections['minicart-form']) {
      apply(sections['minicart-form']);
      p = Promise.resolve();
    } else {
      p = fetch(root + '?sections=minicart-form', { cache: 'no-store', credentials: 'same-origin' })
        .then(function (r) {
          return r.json();
        })
        .then(function (j) {
          apply(j['minicart-form']);
        });
    }
    return p
      .then(KWF.getCart)
      .then(function (cart) {
        KWF.setCount(cart.item_count);
        doc.dispatchEvent(new CustomEvent('kwf:cart-updated', { detail: { cart: cart } }));
        return cart;
      });
  };

  KWF.openDrawer = function () {
    var cart = KWF.cartEl();
    if (cart && typeof cart.open === 'function' && KWF.hasDrawer()) {
      var wrapper = $('.minicart__wrapper', cart);
      if (!wrapper.classList.contains('open')) cart.open();
      return true;
    }
    return false;
  };

  KWF.cartQueue = Promise.resolve();
  KWF.cartRequest = function (path, body) {
    var request = KWF.cartQueue.catch(function () {}).then(function () { return fetch(root + path, {
      method: 'POST',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(Object.assign({ sections: 'minicart-form', sections_url: window.location.pathname }, body)),
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok || Number(j.status) >= 400) {
          var err = new Error(j.description || j.message || 'Something went wrong. Please try again.');
          err.response = j;
          throw err;
        }
        return j;
      });
    }); });
    KWF.cartQueue = request;
    return request;
  };

  /* items: [{id, quantity, properties}] */
  KWF.add = function (items, opts) {
    opts = opts || {};
    return KWF.cartRequest('cart/add.js', { items: items })
      .then(function (res) {
        if (!KWF.hasDrawer()) {
          window.location.href = (window.routes && window.routes.cart_url) || root + 'cart';
          return res;
        }
        return KWF.refreshDrawer(res.sections).then(function () {
          if (opts.open !== false) KWF.openDrawer();
          return res;
        });
      })
      .catch(function (err) {
        KWF.toast(err.message, true);
        throw err;
      });
  };

  KWF.change = function (body) {
    return KWF.cartRequest('cart/change.js', body)
      .then(function (res) {
        return KWF.refreshDrawer(res.sections).then(function () {
          return res;
        });
      })
      .catch(function (err) {
        KWF.toast(err.message, true);
        throw err;
      });
  };

  KWF.update = function (body) {
    return KWF.cartRequest('cart/update.js', body).then(function (res) {
      return KWF.refreshDrawer(res.sections).then(function () {
        return res;
      });
    });
  };

  /* Remember what was just added (also when the theme's own forms add) so the drawer can confirm it. */
  (function watchAdds() {
    if (!window.fetch || window.__kwfFetchPatched) return;
    window.__kwfFetchPatched = true;
    var original = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = original.apply(this, arguments);
      if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
        p.then(function (res) {
          if (!res || !res.ok) return;
          res
            .clone()
            .json()
            .then(function (j) {
              var list = j.items || (j.variant_id ? [j] : []);
              if (KWF.__skipAddWatch) {
                KWF.__skipAddWatch = false;
                return;
              }
              if (!list.length) return;
              KWF.lastAdded = {
                at: Date.now(),
                keys: list.map(function (i) {
                  return String(i.variant_id);
                }),
              };
              setTimeout(function () {
                doc.dispatchEvent(new CustomEvent('kwf:added'));
              }, 0);
            })
            .catch(function () {});
        }).catch(function () {});
      }
      return p;
    };
  })();

  /* --------------------------------------------------------------- dialogs */
  KWF.openDialog = function (dialog) {
    if (!dialog) return;
    if (typeof dialog.showModal === 'function') {
      if (!dialog.open) dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
    doc.documentElement.classList.add('kwf-dialog-open');
  };
  KWF.closeDialog = function (dialog) {
    if (!dialog) return;
    if (typeof dialog.close === 'function' && dialog.open) dialog.close();
    else dialog.removeAttribute('open');
  };
  doc.addEventListener('click', function (e) {
    var dialog = e.target;
    if (dialog && dialog.tagName === 'DIALOG' && dialog.classList.contains('kwf-dialog')) {
      var r = dialog.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) KWF.closeDialog(dialog);
    }
  });
  doc.addEventListener(
    'close',
    function (e) {
      if (e.target && e.target.tagName === 'DIALOG' && !$('dialog.kwf-dialog[open]')) {
        doc.documentElement.classList.remove('kwf-dialog-open');
      }
    },
    true
  );

  /* ------------------------------------------------- generic click handlers */
  doc.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : e.target.parentElement;
    if (!t || !t.closest) return;

    /* open the theme search */
    var search = t.closest('[data-kwf-search]');
    if (search) {
      var pill = window.matchMedia('(max-width: 1024px)').matches ? $('.kh__msearch input[name="q"]') : $('.kh__search--desk input[name="q"]');
      if (pill) { var ms = pill.closest('.kh__msearch'); if (ms) ms.classList.add('is-open'); }
      if (!pill) pill = $('body.kpt-home header.kpt-header input[name="q"]');
      if (pill) {
        e.preventDefault();
        e.stopPropagation();
        pill.scrollIntoView({ block: 'center', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        pill.focus({ preventScroll: true });
        return;
      }
      var toggle = $('.dropdown-toggle .top-search-toggle') || $('.top-search-toggle');
      if (toggle) {
        e.preventDefault();
        e.stopPropagation();
        toggle.click();
      } else {
        window.location.href = (window.routes && window.routes.search_url) || root + 'search';
      }
      return;
    }

    /* quick add (single-variant products) */
    var add = t.closest('[data-kwf-add]');
    if (add) {
      e.preventDefault();
      if (add.classList.contains('is-loading')) return;
      add.classList.add('is-loading');
      var feedback = add.parentElement.querySelector('[data-kwf-add-feedback]');
      if (feedback) feedback.remove();
      KWF.add([{ id: Number(add.getAttribute('data-kwf-add')), quantity: Number(add.getAttribute('data-quantity')) || 1 }])
        .catch(function (error) {
          var message = doc.createElement('p');
          message.setAttribute('data-kwf-add-feedback', '');
          message.setAttribute('role', 'alert');
          message.textContent = error.message;
          add.after(message);
          if (error.response && error.response.status === 422 && /sold out/i.test(error.message)) { add.disabled = true; add.textContent = 'Sold out'; }
        })
        .then(function () {
          add.classList.remove('is-loading');
        });
      return;
    }

    /* open the cart drawer */
    var openCart = t.closest('[data-kwf-open-cart]');
    if (openCart && KWF.hasDrawer()) {
      e.preventDefault();
      e.stopPropagation();
      KWF.openDrawer();
      return;
    }

    /* rails */
    var arrow = t.closest('[data-kwf-prev], [data-kwf-next]');
    if (arrow) {
      var wrap = arrow.closest('[data-kwf-railwrap]');
      var rail = wrap && $('[data-kwf-rail]', wrap);
      if (rail) {
        var dir = arrow.hasAttribute('data-kwf-next') ? 1 : -1;
        rail.scrollBy({ left: dir * rail.clientWidth * 0.9, behavior: 'smooth' });
      }
      return;
    }

    /* tabs */
    var tab = t.closest('[data-kwf-tab]');
    if (tab) {
      var scope = tab.closest('[data-kwf-tabs]');
      var tabs = $$('[data-kwf-tab]', scope);
      var index = tabs.indexOf(tab);
      tabs.forEach(function (el, i) {
        el.classList.toggle('kwf-pill--on', i === index);
        el.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
      $$('[data-kwf-panel]', scope).forEach(function (el, i) {
        el.hidden = i !== index;
        if (i === index) updateRail($('[data-kwf-rail]', el));
      });
      $$('[data-kwf-tab-link]', scope).forEach(function (el, i) {
        el.hidden = i !== index;
      });
      return;
    }
  });

  function updateRail(rail) {
    if (!rail) return;
    var wrap = rail.closest('[data-kwf-railwrap]');
    if (!wrap) return;
    var prev = $('[data-kwf-prev]', wrap);
    var next = $('[data-kwf-next]', wrap);
    var max = rail.scrollWidth - rail.clientWidth - 2;
    if (prev) prev.disabled = rail.scrollLeft <= 2;
    if (next) next.disabled = rail.scrollLeft >= max;
  }
  KWF.initRails = function (scope) {
    $$('[data-kwf-rail]', scope).forEach(function (rail) {
      if (rail.__kwf) return updateRail(rail);
      rail.__kwf = true;
      if (window.ResizeObserver) {
        new ResizeObserver(function () { updateRail(rail); }).observe(rail);
      }
      var ticking = false;
      rail.addEventListener(
        'scroll',
        function () {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(function () {
            ticking = false;
            updateRail(rail);
          });
        },
        { passive: true }
      );
      updateRail(rail);
    });
  };

  /* ------------------------------------------------------ announcement bar */
  function initRotators() {
    $$('[data-kwf-rotator]').forEach(function (el) {
      var msgs = $$('.kwf-ann__msg', el);
      if (msgs.length < 2 || el.__kwf) return;
      el.__kwf = true;
      var i = 0;
      setInterval(function () {
        if (!window.matchMedia('(max-width: 767.98px)').matches) return;
        msgs[i].classList.remove('is-active');
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('is-active');
      }, Number(el.getAttribute('data-interval')) || 4000);
    });
  }

  /* ------------------------------------------------------------- mega menu */
  function initMega() {
    var mega = $('[data-kwf-mega]');
    if (!mega || mega.__kwf) return;
    var trigger = (mega.getAttribute('data-trigger') || '').trim().toLowerCase();
    if (!trigger) return;
    var link = $$('.horizontal-list > li.level0 > menu-item > a, .horizontal-list > li.level0 > a').filter(function (a) {
      return a.textContent.trim().toLowerCase() === trigger;
    })[0];
    if (!link) return;
    mega.__kwf = true;
    var host = link.closest('li.level0');
    host.classList.add('kwf-mega-host');
    link.setAttribute('aria-haspopup', 'true');
    link.setAttribute('aria-expanded', 'false');
    link.setAttribute('aria-controls', mega.id);
    var timer;
    var desktop = window.matchMedia('(min-width: 1025px)');
    function place() {
      var header = link.closest('header') || host;
      mega.style.top = Math.max(0, header.getBoundingClientRect().bottom) + 'px';
    }
    function open() {
      if (!desktop.matches) return;
      clearTimeout(timer);
      place();
      mega.hidden = false;
      requestAnimationFrame(function () {
        mega.classList.add('is-open');
      });
      link.setAttribute('aria-expanded', 'true');
    }
    function close(now) {
      clearTimeout(timer);
      timer = setTimeout(
        function () {
          mega.classList.remove('is-open');
          mega.hidden = true;
          link.setAttribute('aria-expanded', 'false');
        },
        now ? 0 : 160
      );
    }
    host.addEventListener('mouseenter', open);
    host.addEventListener('mouseleave', function () {
      close();
    });
    mega.addEventListener('mouseenter', function () {
      clearTimeout(timer);
    });
    mega.addEventListener('mouseleave', function () {
      close();
    });
    link.addEventListener('focus', open);
    link.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' && desktop.matches) {
        e.preventDefault();
        open();
        var first = $('a', mega);
        if (first) first.focus();
      }
    });
    mega.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        link.focus();
        close(true);
      }
    });
    mega.addEventListener('focusout', function (e) {
      if (!mega.contains(e.relatedTarget) && e.relatedTarget !== link) close();
    });
    window.addEventListener(
      'scroll',
      function () {
        if (!mega.hidden) place();
      },
      { passive: true }
    );
    window.addEventListener('resize', function () {
      if (!desktop.matches) close(true);
      else if (!mega.hidden) place();
    });
  }

  /* -------------------------------------------------------------- countdown */
  function initCountdowns() {
    $$('[data-kwf-countdown]').forEach(function (el) {
      if (el.__kwf) return;
      el.__kwf = true;
      var end = Number(el.getAttribute('data-end')) * 1000;
      var pad = function (n) {
        return String(n).padStart(2, '0');
      };
      function tick() {
        var left = Math.floor((end - Date.now()) / 1000);
        if (left <= 0) {
          var sec = el.closest('[data-kwf-countdown-section]');
          if (sec) sec.hidden = true;
          clearInterval(timer);
          return;
        }
        var d = Math.floor(left / 86400);
        var h = Math.floor((left % 86400) / 3600);
        var m = Math.floor((left % 3600) / 60);
        var s = left % 60;
        var dEl = $('[data-d]', el);
        var dSep = $('[data-d-sep]', el);
        if (dEl) {
          dEl.hidden = d < 1;
          dEl.textContent = pad(d);
        }
        if (dSep) dSep.hidden = d < 1;
        $('[data-h]', el).textContent = pad(h);
        $('[data-m]', el).textContent = pad(m);
        $('[data-s]', el).textContent = pad(s);
      }
      var timer = setInterval(tick, 1000);
      tick();
    });
  }

  /* -------------------------------------------- video: reels, stories, player */
  var player;
  function getPlayer() {
    if (player) return player;
    player = doc.createElement('dialog');
    player.className = 'kwf-dialog kwf-player kwf-scope';
    player.setAttribute('aria-label', 'Video player');
    player.innerHTML =
      '<button type="button" class="kwf-player__x" data-kwf-player-close aria-label="Close">✕</button>' +
      '<div class="kwf-player__grid"><div class="kwf-player__stage" data-stage></div><div class="kwf-player__shop" data-shop hidden></div></div>';
    doc.body.appendChild(player);
    player.addEventListener('close', function () {
      $('[data-stage]', player).innerHTML = '';
      clearTimeout(player.__timer);
    });
    player.addEventListener('click', function (e) {
      if (e.target.closest('[data-kwf-player-close]')) KWF.closeDialog(player);
    });
    return player;
  }

  function stageMedia(item, opts) {
    var html = '';
    if (item.video) {
      html =
        '<video src="' +
        KWF.escape(item.video) +
        '"' +
        (item.poster ? ' poster="' + KWF.escape(item.poster) + '"' : '') +
        ' playsinline autoplay ' +
        (opts.loop ? 'loop ' : '') +
        (opts.controls ? 'controls ' : 'muted ') +
        '></video>';
    } else if (item.poster) {
      html = '<img src="' + KWF.escape(item.poster) + '" alt="">';
    }
    return html;
  }

  /* stories + single story videos */
  function openStories(items, start) {
    var p = getPlayer();
    p.classList.remove('kwf-player--shop');
    $('[data-shop]', p).hidden = true;
    var stage = $('[data-stage]', p);
    var index = start || 0;
    function show() {
      clearTimeout(p.__timer);
      var item = items[index];
      var bars = items.length > 1
        ? '<div class="kwf-player__bars">' +
          items
            .map(function (_, i) {
              return '<i class="' + (i < index ? 'is-done' : i === index ? 'is-active' : '') + '"></i>';
            })
            .join('') +
          '</div>'
        : '';
      stage.innerHTML =
        stageMedia(item, { loop: items.length === 1, controls: items.length === 1 }) +
        bars +
        (item.label ? '<div class="kwf-player__caption">' + KWF.escape(item.label) + '</div>' : '') +
        (items.length > 1
          ? '<button type="button" class="kwf-player__nav kwf-player__nav--prev" data-nav="-1" aria-label="Previous story"></button><button type="button" class="kwf-player__nav kwf-player__nav--next" data-nav="1" aria-label="Next story"></button>'
          : '') +
        (item.link
          ? '<div class="kwf-player__cta"><a class="kwf-btn kwf-btn--light" href="' + KWF.escape(item.link) + '">' + KWF.escape(item.cta || 'Shop now') + ' →</a></div>'
          : '');
      var video = $('video', stage);
      if (items.length > 1) {
        if (video) {
          video.addEventListener('ended', function () {
            go(1);
          });
        } else {
          p.__timer = setTimeout(function () {
            go(1);
          }, 6000);
        }
      }
      if (video) {
        var playing = video.play();
        if (playing && playing.catch) playing.catch(function () {});
      }
    }
    function go(step) {
      index += step;
      if (index < 0) index = 0;
      if (index >= items.length) return KWF.closeDialog(p);
      show();
    }
    stage.onclick = function (e) {
      var nav = e.target.closest('[data-nav]');
      if (nav) go(Number(nav.getAttribute('data-nav')));
    };
    show();
    KWF.openDialog(p);
  }

  /* watch & shop: video + product panel with options and Add to cart */
  function openShopVideo(reel) {
    var p = getPlayer();
    var stage = $('[data-stage]', p);
    var shop = $('[data-shop]', p);
    var handle = reel.getAttribute('data-handle');
    stage.onclick = null;
    stage.innerHTML =
      stageMedia({ video: reel.getAttribute('data-video') }, { loop: true, controls: true }) +
      (reel.getAttribute('data-label') ? '<div class="kwf-player__caption">' + KWF.escape(reel.getAttribute('data-label')) + '</div>' : '');
    shop.hidden = !handle;
    shop.innerHTML = '';
    p.classList.toggle('kwf-player--shop', !!handle);
    KWF.openDialog(p);
    if (!handle) return;
    shop.innerHTML = '<p class="kwf-micro">Loading…</p>';
    fetch(root + 'products/' + handle + '.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (product) {
        var available = product.variants.filter(function (v) {
          return v.available;
        });
        var current = available[0] || product.variants[0];
        var options =
          product.variants.length > 1
            ? '<label class="kwf-sr" for="kwf-player-variant">Choose an option</label><select id="kwf-player-variant" data-variant>' +
              product.variants
                .map(function (v) {
                  return (
                    '<option value="' + v.id + '" data-price="' + v.price + '"' + (v.available ? '' : ' disabled') + (v.id === current.id ? ' selected' : '') + '>' + KWF.escape(v.title) + (v.available ? '' : ' — sold out') + '</option>'
                  );
                })
                .join('') +
              '</select>'
            : '';
        shop.innerHTML =
          (product.featured_image ? '<img src="' + KWF.escape(product.featured_image) + '" alt="" loading="lazy">' : '') +
          '<h3>' + KWF.escape(product.title) + '</h3>' +
          '<p class="kwf-card__price" data-price><b>' + KWF.money(current.price) + '</b>' +
          (current.compare_at_price > current.price ? ' <s>' + KWF.money(current.compare_at_price) + '</s>' : '') + '</p>' +
          options +
          '<button type="button" class="kwf-btn kwf-btn--block" data-add' + (available.length ? '' : ' disabled') + '>' + (available.length ? 'Add to Cart' : 'Sold out') + '</button>' +
          '<a class="kwf-link" href="' + KWF.escape(reel.getAttribute('data-url') || product.url) + '">View full details</a>';
        var select = $('[data-variant]', shop);
        if (select) {
          select.addEventListener('change', function () {
            var opt = select.options[select.selectedIndex];
            $('[data-price]', shop).innerHTML = '<b>' + KWF.money(opt.getAttribute('data-price')) + '</b>';
          });
        }
        $('[data-add]', shop).addEventListener('click', function () {
          var btn = this;
          btn.classList.add('is-loading');
          KWF.add([{ id: Number(select ? select.value : current.id), quantity: 1 }])
            .then(function () {
              KWF.closeDialog(p);
            })
            .catch(function () {})
            .then(function () {
              btn.classList.remove('is-loading');
            });
        });
      })
      .catch(function () {
        shop.innerHTML = '<a class="kwf-btn" href="' + KWF.escape(reel.getAttribute('data-url') || '#') + '">View product</a>';
      });
  }

  doc.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    var story = t.closest('[data-kwf-story]');
    if (story) {
      var all = $$('[data-kwf-story]', story.closest('[data-kwf-stories]'));
      openStories(
        all.map(function (s) {
          return { video: s.getAttribute('data-video'), poster: s.getAttribute('data-poster'), label: s.getAttribute('data-label'), link: s.getAttribute('data-link'), cta: s.getAttribute('data-cta') };
        }),
        all.indexOf(story)
      );
      return;
    }
    var single = t.closest('[data-kwf-video-open]');
    if (single) {
      openStories([{ video: single.getAttribute('data-video'), label: single.getAttribute('data-label'), link: single.getAttribute('data-link'), cta: single.getAttribute('data-cta') }], 0);
      return;
    }
    var reelOpen = t.closest('[data-kwf-reel-open]');
    if (reelOpen) {
      e.preventDefault();
      openShopVideo(reelOpen.closest('[data-kwf-reel]'));
    }
  });

  function initReels() {
    if (!('IntersectionObserver' in window)) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var io =
      KWF.__reelIO ||
      (KWF.__reelIO = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var v = entry.target;
            if (entry.isIntersecting && !reduce) {
              v.muted = true;
              var p = v.play();
              if (p && p.catch) p.catch(function () {});
            } else {
              v.pause();
            }
          });
        },
        { threshold: 0.5 }
      ));
    $$('.kwf-reel__play video').forEach(function (v) {
      if (v.__kwf) return;
      v.__kwf = true;
      v.muted = true;
      v.setAttribute('playsinline', '');
      io.observe(v);
    });
  }

  /* ------------------------------------------------------------------ quiz */
  function initQuiz() {
    var dialog = $('[data-kwf-quiz]');
    if (!KWF.__quizDoc) {
      KWF.__quizDoc = true;
      doc.addEventListener('click', function (e) {
        var opener = e.target.closest && e.target.closest('[data-kwf-quiz-open]');
        if (!opener) return;
        var d = $('[data-kwf-quiz]');
        if (!d) return; /* no quiz on this page: handled by the on-demand loader / fallback link */
        e.preventDefault();
        if (d.__kwfReset) d.__kwfReset();
        KWF.openDialog(d);
      });
    }
    if (!dialog || dialog.__kwf) return;
    dialog.__kwf = true;
    var steps = $$('[data-kwf-quiz-step]', dialog);
    var result = $('[data-kwf-quiz-result]', dialog);
    var bar = $('[data-kwf-quiz-bar]', dialog);
    var answers = [];
    var current = 0;

    function reset() {
      answers = [];
      current = 0;
      showStep();
    }
    dialog.__kwfReset = reset;
    function showStep() {
      steps.forEach(function (s, i) {
        s.hidden = i !== current;
      });
      result.hidden = current < steps.length;
      if (bar) bar.style.width = Math.round((Math.min(current, steps.length) / steps.length) * 100) + '%';
      if (current >= steps.length) loadResult();
    }
    function buildUrl(useSize, usePrice) {
      var base = dialog.getAttribute('data-default-url');
      var params = [];
      var size = '';
      answers.forEach(function (a) {
        if (!a) return;
        if (a.url) base = a.url;
        if (a.kind === 'price' && a.value && usePrice) params.push('filter.v.price.lte=' + encodeURIComponent(a.value));
        if (a.kind === 'size' && a.value) {
          size = a.value;
          if (useSize) {
            var opt = (dialog.getAttribute('data-size-option') || 'Size').toLowerCase();
            params.push('filter.v.option.' + encodeURIComponent(opt) + '=' + encodeURIComponent(a.value));
          }
        }
      });
      return { url: base + (params.length ? '?' + params.join('&') : ''), size: size };
    }
    function fetchPicks(target) {
      var sep = target.url.indexOf('?') > -1 ? '&' : '?';
      return fetch(target.url + sep + 'section_id=kwf-ajax-products')
        .then(function (r) {
          return r.text();
        })
        .then(function (html) {
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          return { items: $$('.kwf-ajax-item', parsed), target: target };
        });
    }
    function loadResult() {
      var grid = $('[data-kwf-quiz-grid]', dialog);
      var sizeNote = $('[data-kwf-quiz-size]', dialog);
      var all = $('[data-kwf-quiz-all]', dialog);
      grid.innerHTML = '<p class="kwf-micro">Finding your picks…</p>';
      var exact = buildUrl(true, true);
      if (exact.size) {
        KWF.store.set('kwf_size', exact.size);
        sizeNote.hidden = false;
        sizeNote.innerHTML = '<b>Your size: ' + KWF.escape(exact.size) + '</b> — saved, so we can show what is in stock for you.';
      } else {
        sizeNote.hidden = true;
      }
      fetchPicks(exact)
        .then(function (res) {
          if (res.items.length) return res;
          return fetchPicks(buildUrl(false, true)).then(function (res2) {
            if (res2.items.length) return res2;
            return fetchPicks(buildUrl(false, false));
          });
        })
        .then(function (res) {
          grid.innerHTML = '';
          if (!res.items.length) {
            grid.innerHTML = '<p class="kwf-micro">No exact matches right now — browse the full collection.</p>';
          }
          res.items.forEach(function (item) {
            grid.appendChild(doc.importNode(item, true));
          });
          all.href = res.target.url;
        })
        .catch(function () {
          grid.innerHTML = '<p class="kwf-micro">Could not load picks. Please try again.</p>';
          all.href = exact.url;
        });
    }
    dialog.addEventListener('click', function (e) {
      var answer = e.target.closest('[data-kwf-quiz-answer]');
      if (answer) {
        var step = answer.closest('[data-kwf-quiz-step]');
        answers[current] = { kind: step.getAttribute('data-kind'), url: answer.getAttribute('data-collection-url'), value: answer.getAttribute('data-value') };
        current++;
        showStep();
        return;
      }
      if (e.target.closest('[data-kwf-quiz-skip]')) {
        answers[current] = null;
        current++;
        showStep();
        return;
      }
      if (e.target.closest('[data-kwf-quiz-restart]')) reset();
    });
  }

  /* --------------------------------------------------------- bundle builder */
  function initBundles() {
    $$('[data-kwf-bundle]').forEach(function (el) {
      if (el.__kwf) return;
      el.__kwf = true;
      var section = el.closest('.kwf-bundle-sec');
      var dialog = $('[data-kwf-bundle-dialog]', section);
      var size = Number(el.getAttribute('data-size')) || 3;
      var bundlePrice = Number(el.getAttribute('data-bundle-price')) || 0;
      var labelPick = el.getAttribute('data-label-pick') || 'Pick item [n]';
      var labelAdd = el.getAttribute('data-label-add') || 'Add bundle to cart';
      var slots = $$('[data-kwf-bundle-slot]', el);
      var cta = $('[data-kwf-bundle-cta]', el);
      var total = $('[data-kwf-bundle-total]', el);
      var options = $$('[data-kwf-bundle-option]', dialog);
      var state = new Array(size).fill(null);
      var target = 0;

      function read(option) {
        var variant = $('[data-kwf-bundle-variant]', option);
        var price = variant.tagName === 'SELECT' ? variant.options[variant.selectedIndex].getAttribute('data-price') : variant.getAttribute('data-price');
        return { productId: option.getAttribute('data-product-id'), variantId: Number(variant.value), price: Number(price), title: option.getAttribute('data-title'), image: option.getAttribute('data-image') };
      }
      function render() {
        var sum = 0;
        var filled = 0;
        slots.forEach(function (slot, i) {
          var item = state[i];
          slot.classList.toggle('is-filled', !!item);
          if (item) {
            filled++;
            sum += item.price;
            slot.innerHTML = (item.image ? '<img src="' + KWF.escape(item.image) + '" alt="' + KWF.escape(item.title) + '">' : '') + '<em>' + (i + 1) + ' ✓</em>';
            slot.setAttribute('aria-label', 'Bundle item ' + (i + 1) + ': ' + item.title + '. Change');
          } else {
            slot.innerHTML = '<span aria-hidden="true">+</span>';
            slot.setAttribute('aria-label', 'Choose bundle item ' + (i + 1));
          }
        });
        var saving = bundlePrice > 0 && sum > bundlePrice ? sum - bundlePrice : 0;
        var next = state.indexOf(null);
        if (next === -1) {
          cta.textContent = labelAdd;
        } else {
          cta.textContent = labelPick
            .replace('[n]', next + 1)
            .replace('[save]', saving && filled === size - 1 ? KWF.money(saving) : '')
            .replace(/\s*·\s*(save|Save)\s*$/, '')
            .trim();
        }
        if (filled) {
          total.hidden = false;
          total.innerHTML =
            filled === size && saving
              ? '<b>' + KWF.money(bundlePrice) + '</b> <s>' + KWF.money(sum) + '</s> · you save ' + KWF.money(saving)
              : filled + ' of ' + size + ' chosen · ' + KWF.money(sum);
        } else {
          total.hidden = true;
        }
        var picked = state
          .filter(Boolean)
          .map(function (i) {
            return i.productId;
          });
        options.forEach(function (o) {
          var isPicked = picked.indexOf(o.getAttribute('data-product-id')) > -1;
          o.classList.toggle('is-picked', isPicked);
          $('[data-kwf-bundle-choose]', o).disabled = isPicked;
        });
      }
      options
        .filter(function (o) {
          return o.hasAttribute('data-prefill');
        })
        .slice(0, size - 1)
        .forEach(function (o, i) {
          state[i] = read(o);
        });
      render();

      el.addEventListener('click', function (e) {
        var slot = e.target.closest('[data-kwf-bundle-slot]');
        if (slot) {
          target = slots.indexOf(slot);
          state[target] = null;
          render();
          KWF.openDialog(dialog);
          return;
        }
        if (e.target.closest('[data-kwf-bundle-cta]')) {
          var next = state.indexOf(null);
          if (next > -1) {
            target = next;
            KWF.openDialog(dialog);
            return;
          }
          cta.classList.add('is-loading');
          KWF.add(
            state.map(function (i) {
              return { id: i.variantId, quantity: 1 };
            })
          )
            .catch(function () {})
            .then(function () {
              cta.classList.remove('is-loading');
            });
        }
      });
      dialog.addEventListener('click', function (e) {
        var choose = e.target.closest('[data-kwf-bundle-choose]');
        if (!choose) return;
        state[target] = read(choose.closest('[data-kwf-bundle-option]'));
        render();
        KWF.closeDialog(dialog);
      });
    });
  }

  /* -------------------------------------------------------------- faq, copy */
  function initFaq() {
    $$('[data-kwf-faq-search]').forEach(function (input) {
      if (input.__kwf) return;
      input.__kwf = true;
      var sec = input.closest('.kwf-faq');
      var items = $$('[data-kwf-faq-list] details', sec);
      var empty = $('[data-kwf-faq-empty]', sec);
      input.addEventListener('input', function () {
        var q = input.value.trim().toLowerCase();
        var shown = 0;
        items.forEach(function (d) {
          var match = !q || d.textContent.toLowerCase().indexOf(q) > -1;
          d.hidden = !match;
          if (match) shown++;
        });
        if (empty) empty.hidden = shown > 0;
      });
    });
    $$('[data-kwf-clamp]').forEach(function (copy) {
      if (copy.__kwf) return;
      copy.__kwf = true;
      var toggle = copy.parentElement.querySelector('[data-kwf-clamp-toggle]');
      if (!toggle || copy.scrollHeight < 150) return;
      copy.classList.add('is-clamped');
      toggle.hidden = false;
      toggle.addEventListener('click', function () {
        var clamped = copy.classList.toggle('is-clamped');
        toggle.textContent = clamped ? 'Read more' : 'Read less';
      });
    });
    /* footer accordions: collapsed on phones, open on desktop */
    var phone = window.matchMedia('(max-width: 767.98px)');
    function syncFooter() {
      $$('.kwf-foot__acc').forEach(function (d) {
        if (phone.matches) d.removeAttribute('open');
        else d.setAttribute('open', '');
      });
    }
    if (!KWF.__footInit && $('.kwf-foot__acc')) {
      KWF.__footInit = true;
      syncFooter();
      if (phone.addEventListener) phone.addEventListener('change', syncFooter);
    }
  }

  /* ---------------------------------------------- capture: email or mobile */
  doc.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.id !== 'kwf-capture-form') return;
    var input = $('[data-kwf-capture-input]', form);
    if (!input) return;
    var value = input.value.trim();
    var digits = value.replace(/[\s\-()+]/g, '');
    if (value.indexOf('@') === -1 && /^\d{10,13}$/.test(digits)) {
      var phoneForm = doc.getElementById('kwf-capture-phone-form');
      if (phoneForm) {
        e.preventDefault();
        $('[data-kwf-capture-phone]', phoneForm).value = value;
        phoneForm.submit();
      }
    } else if (value.indexOf('@') === -1) {
      e.preventDefault();
      input.setCustomValidity('Enter a valid email address or 10-digit mobile number.');
      input.reportValidity();
      input.addEventListener(
        'input',
        function () {
          input.setCustomValidity('');
        },
        { once: true }
      );
    }
  });

  /* ------------------------------------- product recommendations (lazy rail) */
  function initRecs() {
    $$('[data-kwf-recs]').forEach(function (el) {
      if (el.__kwf || $('[data-kwf-recs-content]', el)) return;
      el.__kwf = true;
      fetch(el.getAttribute('data-url'))
        .then(function (r) {
          return r.text();
        })
        .then(function (html) {
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var content = $('[data-kwf-recs-content]', parsed);
          if (content) {
            el.appendChild(doc.importNode(content, true));
            KWF.initRails(el);
          } else {
            var sec = el.closest('.shopify-section');
            if (sec) sec.hidden = true;
          }
        })
        .catch(function () {});
    });
  }

  /* ------------------------------------------------------------------ init */
  KWF.modules = KWF.modules || [];
  /* page modules (collection, product, cart) register here; they run on every init */
  KWF.register = function (fn) {
    KWF.modules.push(fn);
    if (KWF.__ready) {
      try {
        fn();
      } catch (err) {
        if (window.console) console.error('[KWF]', err);
      }
    }
  };
  KWF.init = function () {
    KWF.__ready = true;
    initRotators();
    initMega();
    initCountdowns();
    initReels();
    initQuiz();
    initBundles();
    initFaq();
    initRecs();
    KWF.initRails(doc);
    KWF.modules.forEach(function (fn) {
      try {
        fn();
      } catch (err) {
        if (window.console) console.error('[KWF]', err);
      }
    });
  };

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', KWF.init);
  else KWF.init();
  doc.addEventListener('shopify:section:load', function () {
    KWF.init();
  });
  window.addEventListener('resize', function () {
    $$('[data-kwf-rail]').forEach(updateRail);
  });
})();

/* ==========================================================================
   KWF — Cart drawer
   ========================================================================== */
(function () {
  'use strict';
  var KWF = window.KWF;
  if (!KWF) return;
  var doc = document;
  var $ = function (s, r) {
    return (r || doc).querySelector(s);
  };
  var $$ = function (s, r) {
    return Array.prototype.slice.call((r || doc).querySelectorAll(s));
  };
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var WISH_KEY = 'milano__wishlist-items'; /* the theme's wishlist storage */

  function drawer() {
    return $('.kwf-cart');
  }
  function wishlist() {
    var list = KWF.store.get(WISH_KEY, []);
    return Array.isArray(list) ? list.map(String) : [];
  }
  function saveWishlist(list) {
    KWF.store.set(WISH_KEY, list);
    if (window.wishlistHeader && typeof window.wishlistHeader.init === 'function') window.wishlistHeader.init();
    else
      $$('.wishlist-count').forEach(function (el) {
        el.textContent = list.length;
      });
  }

  /* 02 · add confirmation */
  function applyConfirm() {
    var box = $('[data-kwf-confirm]');
    if (!box) return;
    var last = KWF.lastAdded;
    if (!last || Date.now() - last.at > 60000) {
      box.hidden = true;
      return;
    }
    var line = $$('[data-kwf-line]').filter(function (l) {
      return last.keys.indexOf(l.getAttribute('data-variant-id')) > -1;
    })[0];
    if (!line) {
      box.hidden = true;
      return;
    }
    var title = line.getAttribute('data-title');
    var variant = line.getAttribute('data-variant-title');
    var extra = line.hasAttribute('data-top') && box.getAttribute('data-top-text') ? ' — ' + KWF.escape(box.getAttribute('data-top-text')) : '';
    box.innerHTML = '<span aria-hidden="true">✓</span> <b>Added: ' + KWF.escape(title) + (variant ? ', ' + KWF.escape(variant) : '') + '</b>' + extra;
    box.hidden = false;
  }

  /* 08 (mobile) · saved for later, from the wishlist */
  var savedCache = { key: '', html: null };
  function applySaved() {
    var box = $('[data-kwf-saved]');
    if (!box) return;
    var inCart = $$('[data-kwf-line]').map(function (l) {
      return l.getAttribute('data-product-id');
    });
    var ids = wishlist().filter(function (id) {
      return inCart.indexOf(id) === -1;
    });
    if (!ids.length) {
      box.hidden = true;
      return;
    }
    var key = ids.join(',');
    function paint(items) {
      var list = $('[data-kwf-saved-list]', box);
      if (!items.length) {
        box.hidden = true;
        return;
      }
      $('[data-kwf-saved-count]', box).textContent = items.length;
      list.innerHTML = items
        .slice(0, 2)
        .map(function (i) {
          var action =
            i.available && i.variants === 1
              ? '<button type="button" class="kwf-link" data-kwf-add="' + i.variantId + '">Move to cart</button>'
              : '<a class="kwf-link" href="' + KWF.escape(i.url) + '">' + (i.available ? 'Choose options' : 'View') + '</a>';
          return (
            '<li class="kwf-saved__item">' +
            (i.image ? '<img src="' + KWF.escape(i.image) + '" alt="" loading="lazy">' : '<span></span>') +
            '<span><b>' + KWF.escape(i.price) + '</b> · ' + action + '<br><span class="kwf-micro">' + KWF.escape(i.title).slice(0, 40) + '</span></span></li>'
          );
        })
        .join('');
      box.hidden = false;
    }
    if (savedCache.key === key && savedCache.items) return paint(savedCache.items);
    var searchUrl = (window.routes && window.routes.search_url) || root + 'search';
    fetch(searchUrl + '?section_id=kwf-ajax-products&type=product&options[unavailable_products]=last&q=' + encodeURIComponent('id:' + ids.slice(0, 6).join(' OR id:')))
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var items = $$('.kwf-ajax-item', parsed).map(function (el) {
          return {
            id: el.getAttribute('data-id'),
            variantId: el.getAttribute('data-variant-id'),
            variants: Number(el.getAttribute('data-variants')),
            available: el.getAttribute('data-available') === 'true',
            url: el.getAttribute('data-url'),
            title: el.getAttribute('data-title'),
            price: el.getAttribute('data-price'),
            image: el.getAttribute('data-image'),
          };
        });
        savedCache = { key: key, items: items };
        paint(items);
      })
      .catch(function () {
        box.hidden = true;
      });
  }

  var cartMessages = { element: null, timer: null };
  function initCartMessages() {
    var banner = $('[data-kwf-cart-banner]');
    if (cartMessages.element === banner) return;
    clearInterval(cartMessages.timer);
    cartMessages = { element: banner, timer: null };
    if (!banner) return;
    var messages = $$('[data-kwf-cart-message]', banner);
    var index = 0;
    var motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (messages.length < 2 || banner.getAttribute('data-autoplay') === 'false' || motion.matches) return;
    var seconds = Math.max(3, Math.min(10, Number(banner.getAttribute('data-interval')) || 5));
    cartMessages.timer = setInterval(function () {
      if (!doc.contains(banner)) {
        clearInterval(cartMessages.timer);
        cartMessages.element = null;
        return;
      }
      var cart = drawer();
      if (doc.hidden || motion.matches || !cart || !cart.classList.contains('open') || banner.matches(':hover') || banner.contains(doc.activeElement)) return;
      index = (index + 1) % messages.length;
      messages.forEach(function (message, i) {
        message.classList.toggle('is-active', i === index);
        message.setAttribute('aria-hidden', String(i !== index));
      });
    }, seconds * 1000);
  }
  window.addEventListener('pagehide', function () {
    clearInterval(cartMessages.timer);
    cartMessages.element = null;
  });
  window.addEventListener('pageshow', initCartMessages);

  function afterRender() {
    initCartMessages();
    applyConfirm();
    applySaved();
    if (KWF.initRails) KWF.initRails(drawer() || doc);
  }

  function setBusy(line, busy) {
    if (line) line.classList.toggle('is-busy', busy);
  }

  /* line + drawer interactions */
  doc.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest || !t.closest('.kwf-cart')) return;

    var edit = t.closest('[data-kwf-line-edit]');
    if (edit) {
      var editor = $('[data-kwf-line-editor]', edit.closest('[data-kwf-line]'));
      editor.hidden = !editor.hidden;
      edit.setAttribute('aria-expanded', String(!editor.hidden));
      if (!editor.hidden) $('select', editor).focus();
      return;
    }

    var remove = t.closest('[data-kwf-line-remove]');
    if (remove) {
      var line = remove.closest('[data-kwf-line]');
      setBusy(line, true);
      KWF.change({ id: line.getAttribute('data-key'), quantity: 0 }).catch(function () {
        setBusy(line, false);
      });
      return;
    }

    var wish = t.closest('[data-kwf-line-wishlist]');
    if (wish) {
      var wline = wish.closest('[data-kwf-line]');
      var id = wline.getAttribute('data-product-id');
      var list = wishlist();
      if (list.indexOf(id) === -1) list.push(id);
      saveWishlist(list);
      setBusy(wline, true);
      KWF.change({ id: wline.getAttribute('data-key'), quantity: 0 })
        .then(function () {
          KWF.toast('Moved to your wishlist');
        })
        .catch(function () {
          setBusy(wline, false);
        });
      return;
    }

    var apply = t.closest('[data-kwf-code-apply]');
    if (apply) {
      var input = $('[data-kwf-code]');
      var code = (input.value || '').trim();
      if (!code) return input.focus();
      apply.classList.add('is-loading');
      KWF.update({ discount: code })
        .then(function (res) {
          var codes = res.discount_codes || [];
          var hit = codes.filter(function (c) {
            return String(c.code).toLowerCase() === code.toLowerCase();
          })[0];
          if (hit && hit.applicable) {
            KWF.toast('Code ' + code.toUpperCase() + ' applied');
          } else if (hit && hit.applicable === false) {
            KWF.toast('That code is not valid for this cart', true);
          } else {
            /* older storefront APIs: fall back to the discount link, then refresh */
            return fetch(root + 'discount/' + encodeURIComponent(code)).then(function () {
              return KWF.refreshDrawer();
            });
          }
        })
        .catch(function (err) {
          KWF.toast((err && err.message) || 'Could not apply that code', true);
        })
        .then(function () {
          apply.classList.remove('is-loading');
        });
    }
  });

  doc.addEventListener('change', function (e) {
    var t = e.target;
    if (!t.closest || !t.closest('.kwf-cart')) return;

    /* change size / option in place: add the new variant, then remove the old line */
    if (t.matches('[data-kwf-line-variant]')) {
      e.stopPropagation();
      var line = t.closest('[data-kwf-line]');
      var newId = Number(t.value);
      if (String(newId) === line.getAttribute('data-variant-id')) return;
      setBusy(line, true);
      KWF.__skipAddWatch = true; /* a swap is not a new add: no confirmation */
      KWF.lastAdded = null;
      KWF.cartRequest('cart/add.js', { items: [{ id: newId, quantity: Number(line.getAttribute('data-quantity')) || 1 }], sections: '' })
        .then(function () {
          return KWF.change({ id: line.getAttribute('data-key'), quantity: 0 });
        })
        .catch(function (err) {
          KWF.toast(err.message, true);
          t.value = line.getAttribute('data-variant-id');
          setBusy(line, false);
        });
      return;
    }

    if (t.matches('[data-kwf-gift]')) {
      e.stopPropagation();
      t.disabled = true;
      var p = t.checked ? KWF.add([{ id: Number(t.getAttribute('data-variant-id')), quantity: 1 }], { open: false }) : KWF.change({ id: t.getAttribute('data-key'), quantity: 0 });
      p.catch(function () {
        t.checked = !t.checked;
        t.disabled = false;
      });
      return;
    }

    if (t.matches('[data-kwf-gift-note]')) {
      e.stopPropagation();
      fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { 'Gift note': t.value } }),
      }).catch(function () {});
    }
  });

  doc.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var d = drawer();
    if (!d || !d.classList.contains('open') || $('dialog[open]')) return;
    var cart = KWF.cartEl();
    if (cart && typeof cart.close === 'function') cart.close();
  });

  doc.addEventListener('kwf:added', afterRender);
  doc.addEventListener('kwf:cart-updated', afterRender);

  KWF.register(function () {
    var form = doc.getElementById('minicart-form');
    if (!form || form.__kwfObserved) return afterRender();
    form.__kwfObserved = true;
    /* the theme re-renders #minicart-form after its own cart changes */
    new MutationObserver(function () {
      clearTimeout(form.__kwfTimer);
      form.__kwfTimer = setTimeout(function () {
        afterRender();
        var count = $('[data-kwf-cart]');
        if (count) KWF.setCount(Number(count.getAttribute('data-item-count')) || 0);
      }, 30);
    }).observe(form, { childList: true });
    afterRender();
  });
})();

/* ==========================================================================
   KWF — Collection (filters, sort, show more, saved size), recently viewed
   ========================================================================== */
(function () {
  'use strict';
  var KWF = window.KWF;
  if (!KWF) return;
  var doc = document;
  var $ = function (s, r) {
    return (r || doc).querySelector(s);
  };
  var $$ = function (s, r) {
    return Array.prototype.slice.call((r || doc).querySelectorAll(s));
  };
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var phone = window.matchMedia('(max-width: 767.98px)');

  /* height of the sticky header, for sticky filters / bars */
  function syncStickyTop() {
    var inner = $('header.kwf-header') || $('.shopify-section.section-header');
    var header = inner && (inner.closest('.shopify-section') || inner);
    var top = 0;
    if (header) {
      var pos = getComputedStyle(header).position;
      var rect = inner.getBoundingClientRect();
      /* only reserve space while the header is actually pinned to the top of the viewport */
      if ((pos === 'sticky' || pos === 'fixed') && rect.top <= 1 && rect.bottom > 0) top = rect.height;
    }
    doc.documentElement.style.setProperty('--kwf-sticky-top', Math.round(top) + 'px');
  }

  KWF.savedSize = function () {
    return KWF.store.get('kwf_size', '') || '';
  };

  /* ---------------------------------------------------------- collection */
  function collection() {
    return $('[data-kwf-collection]');
  }
  var state = { tab: 0, sheet: false, busy: false };

  function sizeInputs(el) {
    return $$('.kwf-fgroup--size input[type=checkbox]', el);
  }
  function findSavedSizeInput(el) {
    var saved = KWF.savedSize().toLowerCase();
    if (!saved) return null;
    return (
      sizeInputs(el).filter(function (i) {
        var label = (i.getAttribute('data-label') || i.value || '').toLowerCase();
        return label === saved || i.value.toLowerCase() === saved;
      })[0] || null
    );
  }

  function decorate(el) {
    if (!el) return;
    /* layout state */
    var layout = $('[data-kwf-coll-layout]', el);
    var grid = $('[data-kwf-grid]', el);
    var hideFilters = KWF.store.get('kwf_filters_hidden', false);
    var cols = KWF.store.get('kwf_cols', 0);
    if (layout) layout.classList.toggle('is-nofilters', !!hideFilters);
    var toggle = $('[data-kwf-filters-toggle]', el);
    if (toggle) {
      toggle.setAttribute('aria-expanded', String(!hideFilters));
      $('[data-kwf-filters-toggle-label]', toggle).textContent = hideFilters ? 'Show filters' : 'Hide filters';
    }
    if (grid) {
      var auto = !$('[data-kwf-filters]', el) || hideFilters ? 4 : 3;
      var use = cols || auto;
      grid.setAttribute('data-cols', use);
      $$('[data-kwf-density]', el).forEach(function (b) {
        b.setAttribute('aria-pressed', String(Number(b.getAttribute('data-kwf-density')) === use));
      });
    }
    /* mobile sheet state survives re-render */
    var filters = $('[data-kwf-filters]', el);
    if (filters) {
      filters.classList.toggle('is-open', state.sheet && phone.matches);
      setTab(el, state.tab);
    }
    /* saved size */
    var mine = findSavedSizeInput(el);
    var savedNote = $('[data-kwf-size-saved]', el);
    if (savedNote) savedNote.hidden = !mine;
    var mysize = $('[data-kwf-mysize]', el);
    if (mysize && mine) {
      mysize.hidden = false;
      $('[data-kwf-mysize-label]', mysize).textContent = KWF.savedSize();
      var avail = $('input[name="filter.v.availability"][value="1"]', el);
      $('[data-kwf-mysize-input]', mysize).checked = !!(mine.checked && avail && avail.checked);
    }
    var chip = $('[data-kwf-mysize-chip]', el);
    if (chip && mine) {
      chip.hidden = false;
      chip.classList.toggle('kwf-pill--on', mine.checked);
      chip.setAttribute('aria-pressed', String(mine.checked));
      chip.innerHTML = 'My size: ' + KWF.escape(KWF.savedSize()) + (mine.checked ? ' <span aria-hidden="true">✕</span>' : '');
      /* the generic active chip for the same value would be a duplicate */
      $$('[data-kwf-active-chip]', el).forEach(function (c) {
        if ((c.getAttribute('data-value') || '').toLowerCase() === KWF.savedSize().toLowerCase()) c.hidden = true;
      });
    }
    decorateCards(el);
  }

  /* size-level scarcity on cards for the shopper's saved size (real inventory only) */
  function decorateCards(scope) {
    var saved = KWF.savedSize().toLowerCase();
    var el = collection();
    var low = el ? Number(el.getAttribute('data-low')) || 0 : 0;
    if (!saved) return;
    $$('[data-kwf-card-sizes]', scope || doc).forEach(function (row) {
      var btn = $$('button', row).filter(function (b) {
        return (b.getAttribute('data-size') || '').toLowerCase() === saved;
      })[0];
      if (!btn) return;
      btn.classList.add('is-mine');
      var left = Number(btn.getAttribute('data-left')) || 0;
      var media = row.closest('.kwf-card__media');
      if (!media || !low || left < 1 || left > low || btn.disabled) return;
      var badge = $('.kwf-card__badge', media);
      if (!badge) {
        badge = doc.createElement('span');
        badge.className = 'kwf-card__badge';
        media.appendChild(badge);
      }
      badge.classList.add('kwf-card__badge--warn');
      badge.textContent = left + ' left in ' + btn.getAttribute('data-size');
    });
  }

  function setTab(el, index) {
    var tabs = $$('[data-kwf-ftab]', el);
    if (!tabs.length) return;
    if (index >= tabs.length) index = 0;
    state.tab = index;
    tabs.forEach(function (t, i) {
      t.classList.toggle('is-active', i === index);
      t.setAttribute('aria-selected', String(i === index));
    });
    $$('[data-kwf-fgroup]', el).forEach(function (g, i) {
      g.classList.toggle('is-active', i === index);
    });
  }

  function openSheet(open) {
    var el = collection();
    var filters = el && $('[data-kwf-filters]', el);
    if (!filters) return;
    state.sheet = open;
    filters.classList.toggle('is-open', open);
    var backdrop = $('.kwf-sheet-backdrop');
    if (open && !backdrop) {
      backdrop = doc.createElement('div');
      backdrop.className = 'kwf-sheet-backdrop';
      backdrop.addEventListener('click', function () {
        openSheet(false);
      });
      doc.body.appendChild(backdrop);
    } else if (!open && backdrop) {
      backdrop.remove();
    }
    doc.documentElement.style.overflow = open ? 'hidden' : '';
    if (open) {
      var first = $('.kwf-ftab.is-active', filters) || $('button', filters);
      if (first) first.focus({ preventScroll: true });
    }
  }

  function formUrl(el) {
    var form = $('[data-kwf-filter-form]', el);
    var base = el.getAttribute('data-url');
    var params = new URLSearchParams();
    if (form) {
      new FormData(form).forEach(function (value, key) {
        if (value !== '' && value != null) params.append(key, value);
      });
    } else {
      var sort = $('[data-kwf-sort]', el);
      if (sort && sort.value) params.set('sort_by', sort.value);
    }
    var qs = params.toString();
    return base + (qs ? '?' + qs : '');
  }

  function load(url, opts) {
    opts = opts || {};
    var el = collection();
    if (!el || state.busy) return Promise.resolve();
    state.busy = true;
    el.classList.add('is-loading');
    var sep = url.indexOf('?') > -1 ? '&' : '?';
    return fetch(url + sep + 'section_id=' + encodeURIComponent(el.getAttribute('data-section-id')))
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var next = $('[data-kwf-collection]', parsed);
        if (!next) throw new Error('no section');
        if (opts.append) {
          var grid = $('[data-kwf-grid]', el);
          $$('[data-kwf-grid] > li', next).forEach(function (li) {
            grid.appendChild(doc.importNode(li, true));
          });
          var more = $('[data-kwf-more]', el);
          var nextMore = $('[data-kwf-more]', next);
          if (more && nextMore) more.innerHTML = nextMore.innerHTML;
        } else {
          var focusName = doc.activeElement && doc.activeElement.name;
          var focusValue = doc.activeElement && doc.activeElement.value;
          $('[data-kwf-coll-inner]', el).innerHTML = $('[data-kwf-coll-inner]', next).innerHTML;
          if (opts.history !== false) {
            try {
              window.history[opts.replace ? 'replaceState' : 'pushState']({ kwf: true }, '', url);
            } catch (e) {}
          }
          if (focusName) {
            var again = $$('[name="' + focusName.replace(/"/g, '\\"') + '"]', el).filter(function (i) {
              return i.type !== 'checkbox' || i.value === focusValue;
            })[0];
            if (again) again.focus({ preventScroll: true });
          }
        }
        decorate(el);
      })
      .catch(function () {
        if (!opts.append) window.location.href = url;
      })
      .then(function () {
        state.busy = false;
        el.classList.remove('is-loading');
      });
  }

  var debounceTimer;
  doc.addEventListener('change', function (e) {
    var el = collection();
    if (!el || !el.contains(e.target)) return;
    var t = e.target;
    if (t.matches('[data-kwf-sort]')) {
      var input = $('[data-kwf-sort-input]', el);
      if (input) input.value = t.value;
      $$('[data-kwf-sort]', el).forEach(function (s) {
        s.value = t.value;
      });
      return load(formUrl(el));
    }
    if (t.matches('[data-kwf-mysize-input]')) {
      var mine = findSavedSizeInput(el);
      var avail = $('input[name="filter.v.availability"][value="1"]', el);
      if (mine) mine.checked = t.checked;
      if (avail) avail.checked = t.checked;
      if (!t.checked) sessionStorage.setItem('kwf_size_off', '1');
      return load(formUrl(el));
    }
    if (t.closest('[data-kwf-filter-form]')) {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(
        function () {
          load(formUrl(el));
        },
        t.type === 'number' ? 600 : 80
      );
    }
  });
  doc.addEventListener('submit', function (e) {
    var el = collection();
    if (el && e.target.matches && e.target.matches('[data-kwf-filter-form]')) {
      e.preventDefault();
      load(formUrl(el));
    }
  });

  doc.addEventListener('click', function (e) {
    var el = collection();
    if (!el) return;
    var t = e.target;
    if (!t.closest) return;

    var link = t.closest('[data-kwf-ajax-link]');
    if (link && el.contains(link)) {
      e.preventDefault();
      if (link.hasAttribute('data-kwf-active-chip') || /Clear/.test(link.textContent)) sessionStorage.setItem('kwf_size_off', '1');
      load(link.getAttribute('href'));
      return;
    }
    var more = t.closest('[data-kwf-more-btn]');
    if (more && el.contains(more)) {
      e.preventDefault();
      more.classList.add('is-loading');
      load(more.getAttribute('href'), { append: true });
      return;
    }
    var density = t.closest('[data-kwf-density]');
    if (density) {
      KWF.store.set('kwf_cols', Number(density.getAttribute('data-kwf-density')));
      decorate(el);
      return;
    }
    if (t.closest('[data-kwf-filters-toggle]')) {
      KWF.store.set('kwf_filters_hidden', !KWF.store.get('kwf_filters_hidden', false));
      KWF.store.remove('kwf_cols');
      decorate(el);
      return;
    }
    if (t.closest('[data-kwf-filters-open]')) return openSheet(true);
    if (t.closest('[data-kwf-filters-close]')) return openSheet(false);
    var tab = t.closest('[data-kwf-ftab]');
    if (tab) return setTab(el, Number(tab.getAttribute('data-kwf-ftab')));

    var priceChip = t.closest('[data-kwf-price-chip]');
    if (priceChip) {
      var max = $('[data-kwf-price-max]', el);
      if (max) {
        max.value = priceChip.getAttribute('aria-pressed') === 'true' ? '' : priceChip.getAttribute('data-kwf-price-chip');
        load(formUrl(el));
      }
      return;
    }
    var myChip = t.closest('[data-kwf-mysize-chip]');
    if (myChip) {
      var mine = findSavedSizeInput(el);
      if (mine) {
        mine.checked = !mine.checked;
        if (!mine.checked) sessionStorage.setItem('kwf_size_off', '1');
        load(formUrl(el));
      }
    }
  });

  window.addEventListener('popstate', function () {
    if (collection()) load(window.location.pathname + window.location.search, { history: false });
  });
  doc.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && state.sheet) openSheet(false);
  });

  /* auto-apply the remembered size once per session (no dead-end clicks) */
  function autoSize(el) {
    if (el.__kwfAuto) return;
    el.__kwfAuto = true;
    var off = false;
    try {
      off = sessionStorage.getItem('kwf_size_off') === '1';
    } catch (e) {}
    if (off || /filter\./.test(window.location.search)) return;
    var mine = findSavedSizeInput(el);
    if (!mine || mine.disabled || mine.checked) return;
    mine.checked = true;
    load(formUrl(el), { replace: true });
  }

  /* ----------------------------------------------------- recently viewed */
  var RECENT_KEY = 'kwf_recent';
  function initRecent() {
    var box = $('[data-kwf-recent]');
    var current = box && box.getAttribute('data-current');
    var meta = $('[data-kwf-product-id]');
    var viewing = current || (meta && meta.getAttribute('data-kwf-product-id'));
    var list = KWF.store.get(RECENT_KEY, []);
    if (!Array.isArray(list)) list = [];
    var toShow = list.filter(function (id) {
      return String(id) !== String(viewing);
    });
    if (viewing) {
      list = [String(viewing)].concat(
        list.filter(function (id) {
          return String(id) !== String(viewing);
        })
      ).slice(0, 12);
      KWF.store.set(RECENT_KEY, list);
    }
    if (!box || box.__kwf) return;
    box.__kwf = true;
    var limit = Number(box.getAttribute('data-limit')) || 7;
    toShow = toShow.slice(0, limit);
    if (!toShow.length) return;
    var searchUrl = (window.routes && window.routes.search_url) || root + 'search';
    fetch(searchUrl + '?section_id=kwf-ajax-products&type=product&options[unavailable_products]=last&q=' + encodeURIComponent('id:' + toShow.join(' OR id:')))
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var byId = {};
        $$('.kwf-ajax-item', parsed).forEach(function (el) {
          byId[el.getAttribute('data-id')] = el;
        });
        var items = toShow
          .map(function (id) {
            return byId[id];
          })
          .filter(Boolean);
        if (!items.length) return;
        $('[data-kwf-recent-list]', box).innerHTML = items
          .map(function (el) {
            var title = el.getAttribute('data-title') || '';
            var img = el.getAttribute('data-image');
            return '<li><a href="' + KWF.escape(el.getAttribute('data-url')) + '" aria-label="' + KWF.escape(title) + '">' + (img ? '<img src="' + KWF.escape(img) + '" alt="" loading="lazy">' : '') + '</a></li>';
          })
          .join('');
        box.hidden = false;
      })
      .catch(function () {});
  }

  /* quiz tiles on pages without the quiz: load the quiz dialog from the home page on demand */
  doc.addEventListener(
    'click',
    function (e) {
      var opener = e.target.closest && e.target.closest('[data-kwf-quiz-open]');
      if (!opener || $('[data-kwf-quiz]') || opener.__kwfTried) return;
      e.preventDefault();
      e.stopPropagation();
      opener.__kwfTried = true;
      opener.classList.add('is-loading');
      fetch(root)
        .then(function (r) {
          return r.text();
        })
        .then(function (html) {
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var dialog = $('[data-kwf-quiz]', parsed);
          if (!dialog) throw new Error('no quiz');
          doc.body.appendChild(doc.importNode(dialog, true));
          KWF.init();
          opener.classList.remove('is-loading');
          opener.click();
        })
        .catch(function () {
          window.location.href = opener.getAttribute('href') || root;
        });
    },
    true
  );

  KWF.register(function () {
    syncStickyTop();
    var el = collection();
    if (el) {
      decorate(el);
      autoSize(el);
    }
    initRecent();
    if (/[?&]quiz=1/.test(window.location.search) && $('[data-kwf-quiz]') && !KWF.__quizAuto) {
      KWF.__quizAuto = true;
      KWF.openDialog($('[data-kwf-quiz]'));
    }
  });
  window.addEventListener('resize', syncStickyTop);
  window.addEventListener('scroll', syncStickyTop, { passive: true });
})();

/* ==========================================================================
   KWF — Product page
   ========================================================================== */
(function () {
  'use strict';
  var KWF = window.KWF;
  if (!KWF) return;
  var doc = document;
  var $ = function (s, r) {
    return (r || doc).querySelector(s);
  };
  var $$ = function (s, r) {
    return Array.prototype.slice.call((r || doc).querySelectorAll(s));
  };
  var phone = window.matchMedia('(max-width: 767.98px)');
  var data = null;

  function pdp() {
    return $('.kwf-pdp');
  }
  function readData() {
    var el = $('[data-kwf-product-json]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }
  function mainForm() {
    var root = pdp();
    return root ? $('.product-detail__information product-form form, .product-detail__information form[data-type="add-to-cart-form"]', root) : null;
  }
  function currentVariant() {
    if (!data) return null;
    var form = mainForm();
    var input = form && $('[name="id"]', form);
    var id = input ? Number(input.value) : 0;
    return (
      data.variants.filter(function (v) {
        return v.id === id;
      })[0] || data.variants[0]
    );
  }
  function sizeIndex() {
    var tools = $('[data-kwf-sizetools]');
    var name = (tools && tools.getAttribute('data-size-option')) || 'size';
    return data.options
      .map(function (o) {
        return String(o).toLowerCase();
      })
      .indexOf(name);
  }
  function sizeInputs(ix) {
    var root = pdp();
    var name = data.options[ix];
    return $$('.product-detail__information variant-radios-detail input[type="radio"], .product-detail__information variant-group-detail input[type="radio"]', root).filter(function (i) {
      return i.name === name;
    });
  }

  /* per-size "N left" badges for the currently selected other options (real tracked inventory) */
  function paintSizes(variant) {
    var ix = sizeIndex();
    if (ix < 0 || !variant) return;
    sizeInputs(ix).forEach(function (input) {
      var label = input.nextElementSibling;
      if (!label || label.tagName !== 'LABEL') return;
      var match = data.variants.filter(function (v) {
        return v.options.every(function (opt, i) {
          return i === ix ? opt === input.value : opt === variant.options[i];
        });
      })[0];
      var badge = $('.kwf-left', label);
      var show = match && match.available && match.left > 0 && data.low > 0 && match.left <= data.low;
      if (show) {
        if (!badge) {
          badge = doc.createElement('i');
          badge.className = 'kwf-left';
          label.appendChild(badge);
        }
        badge.textContent = match.left + ' left';
      } else if (badge) {
        badge.remove();
      }
    });
  }

  function paint() {
    var variant = currentVariant();
    if (!variant) return;
    /* stock bar */
    var stock = $('[data-kwf-stock]');
    if (stock) {
      var threshold = Number(stock.getAttribute('data-threshold')) || 10;
      var low = variant.available && variant.left > 0 && variant.left <= threshold;
      stock.hidden = !low;
      if (low) {
        $('[data-kwf-stock-count]', stock).textContent = variant.left;
        $('[data-kwf-stock-variant]', stock).textContent = data.variants.length > 1 ? ' in ' + variant.title : '';
        $('[data-kwf-stock-bar]', stock).style.width = Math.min(100, Math.round((variant.left / threshold) * 100)) + '%';
      }
    }
    /* EMI split and prepaid price */
    $$('[data-kwf-emi]').forEach(function (el) {
      el.textContent = KWF.money(Math.floor(variant.price / (Number(el.getAttribute('data-months')) || 3)));
    });
    var prepaid = $('[data-kwf-prepaid]');
    if (prepaid) {
      var value = Number(prepaid.getAttribute('data-value')) || 0;
      var saving = prepaid.getAttribute('data-type') === 'percent' ? Math.round((variant.price * value) / 100) : value * 100;
      $('[data-kwf-prepaid-price]', prepaid).textContent = KWF.money(variant.price - saving);
    }
    paintSizes(variant);
    paintAtc(variant);
    paintLook();
  }

  /* "Add to Cart · ₹999" on the main button (the theme owns the label text itself) */
  function paintAtc(variant) {
    var root = pdp();
    var button = root && $('.product-detail__information .product-form__submit', root);
    if (!button) return;
    var label = $('.btn-label', button) || button;
    var price = $('.kwf-atc-price', button);
    if (!variant.available || button.disabled) {
      if (price) price.remove();
      return;
    }
    if (!price) {
      price = doc.createElement('span');
      price.className = 'kwf-atc-price';
      label.appendChild(price);
    }
    var text = ' · ' + KWF.money(variant.price);
    if (price.textContent !== text) price.textContent = text;
  }

  /* remembered size: preselect it (no variant chosen in the URL) and say so */
  function applySavedSize() {
    var ix = sizeIndex();
    var note = $('[data-kwf-size-note]');
    if (ix < 0) return;
    var saved = KWF.store.get('kwf_size', '');
    if (!saved) return;
    var input = sizeInputs(ix).filter(function (i) {
      return i.value.toLowerCase() === String(saved).toLowerCase();
    })[0];
    if (!input) return;
    var has = data.variants.some(function (v) {
      return v.options[ix] === input.value && v.available;
    });
    if (!has) return;
    if (!/[?&]variant=/.test(window.location.search) && !input.checked && !input.classList.contains('option-disabled')) {
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (note) {
      $('[data-kwf-size-value]', note).textContent = input.value;
      note.hidden = false;
    }
  }

  /* mobile gallery: counter + thumbnail strip built from the theme gallery */
  function initGallery() {
    var root = pdp();
    var viewer = root && $('[id^="GalleryViewer-"]', root);
    if (!viewer || viewer.__kwf || !/^grid/.test(root.getAttribute('data-desktop-layout') || '')) return;
    var slides = Array.prototype.slice.call(viewer.children).filter(function (c) {
      return c.offsetParent !== null || phone.matches;
    });
    if (slides.length < 2) return;
    viewer.__kwf = true;
    var count = doc.createElement('span');
    count.className = 'kwf-gallery-count';
    count.setAttribute('aria-hidden', 'true');
    var thumbs = doc.createElement('div');
    thumbs.className = 'kwf-thumbs';
    thumbs.setAttribute('role', 'tablist');
    thumbs.setAttribute('aria-label', 'Product images');
    slides.forEach(function (slide, i) {
      var img = $('img', slide);
      var b = doc.createElement('button');
      b.type = 'button';
      b.setAttribute('role', 'tab');
      b.setAttribute('aria-label', 'Show image ' + (i + 1));
      if ($('video, iframe, .deferred-media, deferred-media', slide)) b.setAttribute('data-video', '');
      if (img) b.innerHTML = '<img src="' + (img.currentSrc || img.src) + '" alt="" loading="lazy">';
      b.addEventListener('click', function () {
        viewer.scrollTo({ left: slide.offsetLeft - viewer.offsetLeft, behavior: 'smooth' });
      });
      thumbs.appendChild(b);
    });
    viewer.insertAdjacentElement('afterend', thumbs);
    viewer.insertAdjacentElement('afterend', count);
    function sync() {
      var index = Math.round(viewer.scrollLeft / Math.max(1, viewer.clientWidth));
      index = Math.max(0, Math.min(slides.length - 1, index));
      count.textContent = index + 1 + ' / ' + slides.length;
      $$('button', thumbs).forEach(function (b, i) {
        b.classList.toggle('is-active', i === index);
        b.setAttribute('aria-selected', String(i === index));
      });
    }
    viewer.addEventListener('scroll', function () {
      requestAnimationFrame(sync);
    }, { passive: true });
    sync();
  }

  /* complete the look */
  function paintLook() {
    var box = $('[data-kwf-look]');
    if (!box || !data) return;
    var variant = currentVariant();
    var total = variant.price;
    var compare = Math.max(variant.compare, variant.price);
    var n = 1;
    $$('[data-kwf-look-item]', box).forEach(function (li) {
      var on = $('[data-kwf-look-check]', li).checked;
      li.classList.toggle('is-off', !on);
      var v = $('[data-kwf-look-variant]', li);
      var src = v.tagName === 'SELECT' ? v.options[v.selectedIndex] : v;
      var price = Number(src.getAttribute('data-price')) || 0;
      $('.kwf-look__price', li).textContent = KWF.money(price);
      if (!on) return;
      n++;
      total += price;
      compare += Math.max(Number(src.getAttribute('data-compare')) || 0, price);
    });
    $('[data-kwf-look-total]', box).textContent = KWF.money(total);
    $('[data-kwf-look-compare]', box).textContent = compare > total ? KWF.money(compare) : '';
    var btn = $('[data-kwf-look-add]', box);
    btn.textContent = (box.getAttribute('data-label-add') || 'Add [n] items').replace('[n]', n).replace(/items\b/, n === 1 ? 'item' : 'items');
    btn.disabled = !variant.available;
  }
  function initLook() {
    var sec = $('[data-kwf-look-section]');
    if (!sec || sec.__kwf) return;
    sec.__kwf = true;
    var url = sec.getAttribute('data-url');
    if (!url) return paintLook();
    fetch(url)
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var items = $$('[data-kwf-look-items] > li', parsed);
        if (!items.length) return;
        var list = $('[data-kwf-look-list]', sec);
        items.forEach(function (li) {
          list.appendChild(doc.importNode(li, true));
        });
        sec.hidden = false;
        paintLook();
      })
      .catch(function () {});
  }

  /* compare similar styles */
  function initCompare() {
    var sec = $('[data-kwf-cmp]');
    if (!sec || sec.__kwf) return;
    sec.__kwf = true;
    fetch(sec.getAttribute('data-url'))
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var items = [$('[data-kwf-cmp-this] [data-kwf-cmp-item]', sec)].concat($$('[data-kwf-cmp-items] [data-kwf-cmp-item]', parsed)).filter(Boolean);
        if (items.length < 2) return;
        var cols = items.map(function (el) {
          return {
            isThis: el.hasAttribute('data-this'),
            title: el.getAttribute('data-title'),
            url: el.getAttribute('data-url'),
            price: el.getAttribute('data-price'),
            attrs: $$('[data-kwf-cmp-attr]', el).map(function (a) {
              return { label: a.getAttribute('data-label'), value: a.textContent.trim() };
            }),
          };
        });
        var rows = cols[0].attrs
          .map(function (a, i) {
            return {
              label: a.label,
              values: cols.map(function (c) {
                return (c.attrs[i] && c.attrs[i].value) || '';
              }),
            };
          })
          .filter(function (r) {
            return (
              r.values.filter(function (v) {
                return v;
              }).length >= 2
            );
          });
        if (!rows.length) return;
        var cls = function (i) {
          return i === 0 ? ' class="kwf-cmp__us"' : i === 2 ? ' class="kwf-cmp__c3"' : '';
        };
        var cellCls = function (i) {
          return i === 2 ? ' class="kwf-cmp__c3"' : '';
        };
        var head =
          '<tr><th scope="col"><span class="kwf-sr">Attribute</span></th>' +
          cols
            .map(function (c, i) {
              return '<th scope="col"' + cls(i) + '>' + (c.isThis ? KWF.escape(sec.getAttribute('data-this-label') || 'This') : '') + ' ' + (c.isThis ? '· ' : '') + KWF.escape(c.price) + '<span>' + KWF.escape(c.title) + '</span></th>';
            })
            .join('') +
          '</tr>';
        var body = rows
          .map(function (r) {
            return (
              '<tr><th scope="row">' + KWF.escape(r.label) + '</th>' +
              r.values
                .map(function (v, i) {
                  return '<td' + cellCls(i) + '>' + (v ? KWF.escape(v) : '—') + '</td>';
                })
                .join('') +
              '</tr>'
            );
          })
          .join('');
        var links =
          '<tr><th scope="row"><span class="kwf-sr">Link</span></th>' +
          cols
            .map(function (c, i) {
              return '<td' + cellCls(i) + '>' + (c.isThis ? '' : '<a href="' + KWF.escape(c.url) + '">' + KWF.escape(sec.getAttribute('data-view-label') || 'View') + ' →</a>') + '</td>';
            })
            .join('') +
          '</tr>';
        $('[data-kwf-cmp-table]', sec).innerHTML = '<table class="kwf-cmp kwf-cmp--products"><thead>' + head + '</thead><tbody>' + body + links + '</tbody></table>';
        sec.hidden = false;
      })
      .catch(function () {});
  }

  doc.addEventListener('change', function (e) {
    var t = e.target;
    if (!data || !t.closest) return;
    if (t.matches('[data-kwf-look-check], [data-kwf-look-variant]')) return paintLook();
    if (t.closest('.kwf-pdp')) {
      /* the theme updates the hidden variant id, then we repaint from real variant data */
      setTimeout(paint, 60);
      var ix = sizeIndex();
      if (ix > -1 && t.type === 'radio' && t.name === data.options[ix] && e.isTrusted) KWF.store.set('kwf_size', t.value);
    }
  });

  doc.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    var copy = t.closest('[data-kwf-copy]');
    if (copy) {
      var code = copy.getAttribute('data-kwf-copy');
      var done = function () {
        copy.textContent = 'Copied';
        setTimeout(function () {
          copy.textContent = 'Copy';
        }, 2000);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, done);
      else done();
      return;
    }
    var addQty = t.closest('[data-kwf-add-qty]');
    if (addQty && data) {
      var v = currentVariant();
      addQty.classList.add('is-loading');
      KWF.add([{ id: v.id, quantity: Number(addQty.getAttribute('data-kwf-add-qty')) || 2 }])
        .catch(function () {})
        .then(function () {
          addQty.classList.remove('is-loading');
        });
      return;
    }
    var lookAdd = t.closest('[data-kwf-look-add]');
    if (lookAdd && data) {
      var items = [{ id: currentVariant().id, quantity: 1 }];
      $$('[data-kwf-look-item]').forEach(function (li) {
        if ($('[data-kwf-look-check]', li).checked) items.push({ id: Number($('[data-kwf-look-variant]', li).value), quantity: 1 });
      });
      lookAdd.classList.add('is-loading');
      KWF.add(items)
        .catch(function () {})
        .then(function () {
          lookAdd.classList.remove('is-loading');
        });
      return;
    }
    var share = t.closest('[data-kwf-share]');
    if (share && navigator.share) {
      navigator.share({ title: share.getAttribute('data-title'), url: share.getAttribute('data-url') }).catch(function () {});
    }
  });

  /* sticky bar visible -> the mobile bottom nav gives up the thumb zone */
  function watchSticky() {
    var bar = $('.kwf-pdp sticky-add-cart');
    if (!bar || bar.__kwf) return;
    bar.__kwf = true;
    var sync = function () {
      var visible = getComputedStyle(bar).visibility !== 'hidden' && getComputedStyle(bar).display !== 'none' && bar.getBoundingClientRect().top < window.innerHeight;
      doc.body.classList.toggle('kwf-sticky-on', visible);
    };
    var later;
    var resync = function () {
      sync();
      clearTimeout(later);
      later = setTimeout(sync, 500); /* the bar fades in: visibility flips at the end of its transition */
    };
    new MutationObserver(resync).observe(bar, { attributes: true, attributeFilter: ['class', 'style'] });
    bar.addEventListener('transitionend', sync);
    window.addEventListener('scroll', resync, { passive: true });
    sync();
  }

  KWF.register(function () {
    if (!pdp()) return;
    data = readData();
    if (!data) return;
    var share = $('[data-kwf-share]');
    if (share && navigator.share) share.hidden = false;
    var notify = $('[data-kwf-notify]');
    if (notify && /contact_posted=true/.test(window.location.search)) notify.open = true;
    initGallery();
    if (!KWF.__pdpInit) {
      KWF.__pdpInit = true;
      applySavedSize();
      /* the theme rewrites the button label on variant change: keep the price on it */
      var button = $('.kwf-pdp .product-detail__information .product-form__submit');
      if (button) {
        new MutationObserver(function () {
          var v = currentVariant();
          if (v) paintAtc(v);
        }).observe(button, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
      }
    }
    paint();
    initLook();
    initCompare();
    watchSticky();
  });
})();


